import DraggableObject from 'ember-drag-drop/components/draggable-object';

export default DraggableObject;
